import { Directive, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { EventBusBase } from '@skylab-shared/core';
import { UIEvents } from '../utils/ui-events';

@Directive()
export class QlValueAccessor implements ControlValueAccessor {
    @ViewChild('inputRef') protected inputRef!: ElementRef<HTMLInputElement>;

    private onChange: (value: any) => void = () => {};
    private onTouched: () => void = () => {};
    protected lastValue: any;
    protected previousValue: any;

    private isEdited = false;

    public constructor(
        protected elm: ElementRef,
        protected eventBus: EventBusBase
    ) {}

    public writeValue(value: any): void {
        this.value = this.lastValue = value;
    }

    public handleChangeEvent(_elm: HTMLElement, value: any): void {
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.onChange(value);
            this.markDirty();
            this.value = value;
        }
    }

    private markDirty(): void {
        if (!this.isEdited) {
            this.eventBus.emit(UIEvents.ControlEdited, this.elm.nativeElement);
            this.isEdited = true;
        }
    }

    public registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        if (this.inputRef) this.inputRef.nativeElement.disabled = isDisabled;
    }

    private _value: any;
    public get value(): any {
        return this._value;
    }
    public set value(value: any) {
        this._value = value;
    }

    protected handleBlurEvent(elm: HTMLElement): void {
        if (elm === this.inputRef.nativeElement) {
            this.onTouched();
            this.previousValue = this.lastValue;
        }
    }
}
